import { render, staticRenderFns } from "./topIndex.vue?vue&type=template&id=1be24d03"
import script from "./topIndex.vue?vue&type=script&lang=js"
export * from "./topIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports